// components/PermissionGuard.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { canAccessPath, getFirstAccessiblePath, hasPermission, isStaffSession } from "../utils/permissions";

const PermissionGuard = ({ 
  module, 
  path, 
  requiredLevel = 'view', 
  children,
  redirectTo = '/staff'
}) => {
  if (!isStaffSession()) {
    return children;
  }
  if (!hasPermission(module, path, requiredLevel)) {
    return <Navigate to={getFirstAccessiblePath() || redirectTo} replace />;
  }
  return children;
};

export const RouteAccessGuard = ({ children }) => {
  const location = useLocation();
  if (!isStaffSession() || canAccessPath(location.pathname)) return children;
  const fallback = getFirstAccessiblePath();
  if (fallback) return <Navigate to={fallback} replace />;
  return <div style={{ padding: 32 }}><h1>Access Denied</h1><p>No module permissions have been assigned to this account.</p></div>;
};

export default PermissionGuard;